export class ValidationMessageResources {
  public static emailRequired = 'Email is required';
  public static emailInvalid = 'You must use a valid email address';
  public static mobileInvalid = 'Must be a valid Australian mobile number';
  public static internationalMobileInvalid = 'Must be a valid mobile number';
  public static invalidDate = 'Invalid Date';
  public static invalidPattern = 'Invalid pattern';
  public static atLeastOneFundingAmount = 'Either the marketing amount or other amount is required';
}
